import { Avatar, Skeleton } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { ReactNode } from "react";
import { Link, useNavigate } from "react-router-dom";
import classes from "./home.module.scss";

type Props = {
  title?: string | null;
  subtitle: string;
  avatarUrl?: string | null;
  // Letter shown when there is no picture; defaults to the title's first letter.
  avatarText?: string;
  to?: string;
  actions?: ReactNode;
};

export default function HomeHeader({ title, subtitle, avatarUrl, avatarText, to, actions }: Props) {
  const navigate = useNavigate();
  const identity = (
    <>
      <Avatar src={avatarUrl || null} size={40} radius="xl" color="myColor" aria-hidden>
        {avatarText ?? title?.trim().charAt(0)}
      </Avatar>
      <span className={classes.identityText}>
        {title ? <span className={classes.title}>{title}</span> : <Skeleton width={120} height={14} my={4} />}
        <span className={classes.subtitle}>{subtitle}</span>
      </span>
    </>
  );

  return (
    <header className={classes.header}>
      {to ? (
        <Link to={to} className={classes.identity}>
          {identity}
        </Link>
      ) : (
        <div className={classes.identity}>{identity}</div>
      )}
      <div className={classes.headerActions}>
        <button
          type="button"
          className={classes.iconButton}
          aria-label="جستجوی مشتری"
          onClick={() => navigate("/dashboard/customers/search")}
        >
          <IconSearch size={24} stroke={1.7} aria-hidden />
        </button>
        {actions}
      </div>
    </header>
  );
}
